import React from 'react';
import { render } from 'react-dom';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import App          from './modules/App';
import Home         from './modules/Home';
import Landing      from './modules/landing/Landing';
import Masterplan   from './modules/land-for-sale/Masterplan';
import Stageplan    from './modules/land-for-sale/Stageplan';
import Lotplan      from './modules/land-for-sale/Lotplan';
import LandSearch      from './modules/land-for-sale/LandSearch';
import HouseAndLand from './modules/house-and-land/HouseAndLand';
import Package      from './modules/house-and-land/Package';
// import Location     from './modules/location/Location';
import NotFound     from './modules/NotFound';
import './index.css';

render((
	<Router history={browserHistory}>
		<Route path="/" component={App}>
			<IndexRoute component={Home}/>
			<Route path="/" component={Landing}/>

            {/*Staging*/}
            {/*<Route path="/~theedgebaldivis/land-for-sale" component={Masterplan}/>*/}
            {/*<Route path="/~theedgebaldivis/land-for-sale/stage/:stage" component={Stageplan}/>*/}
            {/*<Route path="/~theedgebaldivis/land-for-sale/lot/:lot" component={Lotplan}/>*/}
            {/*<Route path="/~theedgebaldivis/house-and-land" component={HouseAndLand}/>*/}
            {/*<Route path="/~theedgebaldivis/house-and-land/package/:package" component={Package}/>*/}

            {/*Live*/}
			<Route path="/land-for-sale" component={{main:Masterplan, search:LandSearch}}/>
			<Route path="/land-for-sale/stage/:stage" component={{main:Stageplan, search:LandSearch}}/>
			<Route path="/land-for-sale/lot/:lot" component={{main:Lotplan, search:LandSearch}}/>
			<Route path="/house-and-land" component={{main:HouseAndLand, search:null}}/>
			<Route path="/house-and-land/package/:package" component={{main:Package, search:null}}/>

			{/*<Route path="/location" component={Location}/>*/}
			<Route path="*" component={NotFound} />
		</Route>
	</Router>
), document.getElementById('InSiteIntereactive'))



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/